import { FunctionComponent } from "react";

import AppLogo from "@/assets/images/favicon.png";

export const Logo: FunctionComponent<{
	handleClick?: () => void;
	className?: string;
	containerClassName?: string;
}> = ({ handleClick, className = "", containerClassName }) => {
	return (
		<div
			className={`flex items-center justify-center h-[44px] w-[44px] rounded-[11px] shadow-medium border-[0.28px] border-[#E6E6EC] ${containerClassName}`}
		>
			<img
				alt="logo"
				className={`w-[34px] h-[28px] cursor-pointer z-40 text-primary-blue ${className}`}
				src={`${AppLogo}`}
				onClick={() => handleClick?.()}
			/>
		</div>
	);
};
